import React, { useEffect } from 'react';

// MUI
import { makeStyles, Divider, Button, Typography, Toolbar } from '@material-ui/core';

// styles
// import "../../styles/Products.css";

// dependends
import AddToPrintQueue from '../PrintQueue/AddToPrintQueue';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  button: {
    color: '#ff682c',
    background: '#EEEEEE',
    marginLeft: 50,
  },
  divider: {
    marginLeft: 50,
    background: '#000',
    width: 2,
  },
  title: {
    flexGrow: 1,
  },
  select: {
    marginLeft: 20,
  },
}));

const TableToolBar = (props) => {
  const classes = useStyles();
  const { numSelected, productIdList, showMergeList, refresh } = props;
  useEffect(() => {}, [refresh]);

  return (
    <Toolbar>
      {numSelected > 0 ? (
        <Typography color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography variant="h6" id="tableTitle" component="div">
          Products
        </Typography>
      )}
      {numSelected > 0 && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            className={classes.divider}
          />
          {/* The one place labels are queued from. It replaced a bare printer glyph
              (nobody found it) and then a per-row stepper (too noisy on every row):
              one control, only on screen once something is selected. */}
          <div id="tour-queue-add" style={{ marginLeft: 50 }}>
            <AddToPrintQueue productUuids={productIdList} />
          </div>
          <Button
            variant="contained"
            className={classes.button}
            onClick={showMergeList}
          >
            Merge Options
          </Button>
        </>
      )}
    </Toolbar>
  );
};

export default TableToolBar;
